import axios from 'axios';
import CommonConstants from '../utils/CommonConstants';
import { warehouseIDToCode } from '../utils/warehouseFlags';
const apiUrl = CommonConstants.Actions.api;

export function getParcel(token){
  return function(dispatch)  {
      dispatch({type: 'GET_PARCEL_FETCHING',});
      axios.get(apiUrl+'parcels',
      token).then((response) => {
      dispatch({type: 'GETPARCEL_USER_FULFILLED', payload: response.data,});
    }).catch((err) =>{
      dispatch({type: 'GETPARCEL_USER_REJECTED', payload: err,})
    })
  }
}

export function getProhibitedParcel(token){
  return function(dispatch)  {
      dispatch({type: 'GETPROHIBITED_PARCEL_FETCHING',});
      axios.get(apiUrl+'parcels?status=prohibited',
      token).then((response) => {
      dispatch({type: 'GETPROHIBITED_PARCEL_FULFILLED', payload: response.data,})
    }).catch((err) =>{
      dispatch({type: 'GETPARCEL_USER_REJECTED', payload: err,})
    })
  }
}

export function getParcelById(id){
  const token = localStorage.jwtToken
	return function(dispatch){
		dispatch({type: 'PARCEL_FETCHING',});
		axios.get(apiUrl+'parcels/'+id,token)
		.then((response) => {
			dispatch({type: 'GET_PARCEL_FULFILLED', payload: response.data,})
		}).catch((err) =>{
			dispatch({type: 'GET_PARCEL_REJECTED', payload: err,})
		})
	}
}

export function updateInsuredValue(token,parcel_id,insured_value,warehouse_id,destination_country){
	return function(dispatch){
    dispatch({ type: 'PARCEL_UPDATING' })
		axios.put(apiUrl+'parcels/'+parcel_id+'/update-insured-value',
    {insured_value,
      warehouse_id,
      destination_country
    })
		.then((response) => {
      dispatch({type: 'UPDATE_INSURED_VALUE_FULFILLED', payload: response.data,})

      axios.post(apiUrl+'users/cart',{"data":{"warehouse":warehouseIDToCode(warehouse_id).toLowerCase(),"prohibited":null, "offsize": null}})
      .then((response) => {
        dispatch({type: 'GET_CART_DATA_FULFILLED', payload: response.data,});
        dispatch({ type: 'PARCEL_UPDATED' });
      })
      .catch((err) =>{
        dispatch({type: 'GET_CART_DATA_REJECTED', payload: err,})
        dispatch({ type: 'PARCEL_UPDATED' });
      })
		}).catch((error) =>{
			dispatch({type: 'UPDATE_INSURED_VALUE_REJECTED', payload: error.response,})
      dispatch({ type: 'PARCEL_UPDATED' });
		})
	}
}

export function showInsuredValueErrorMessage(){

	return function (dispatch){
		dispatch({type: 'SHOW_INSURED_VALUE_ERROR_MESSAGE',});
	}
}

export function showInsuredValueLessThanZeroErrorMessage(){

	return function (dispatch){
		dispatch({type: 'SHOW_INSURED_VALUE_LESS_THAN_ZERO_ERROR_MESSAGE',});
	}
}

export function showInsuredValueNaNErrorMessage(){

	return function (dispatch){
		dispatch({type: 'SHOW_INSURED_VALUE_NAN_ERROR_MESSAGE',});
	}
}

export function removeInsuredValueErrorMessage(){

	return function (dispatch){
		dispatch({type: 'REMOVE_INSURED_VALUE_ERROR_MESSAGE',});
	}

}

export function updateInsuredValueAndRecalculateShipmentCost(parcel_id, insured_value,token, chkItemArray, insurance, warehouse_id, shipment_location_details, willResetInsuredError,sc_protect){
	return function (dispatch) {
    dispatch({ type: 'PARCEL_UPDATING' })
		axios.put(apiUrl+'parcels/'+parcel_id+'/update-insured-value',
    { insured_value, 
      warehouse_id,
      "destination_country": shipment_location_details.destination
    })
		.then(
			(update_response) => {
        dispatch({type: 'UPDATE_INSURED_VALUE_FULFILLED', payload: update_response.data,})
        dispatch({ type: 'PARCEL_UPDATING' })
        axios.post(apiUrl+'users/cart',{"data":{"warehouse":warehouseIDToCode(Object.values(warehouse_id)[0]).toLowerCase(),"prohibited":null, "offsize": null}})
        .then((response) => {
          dispatch({type: 'GET_CART_DATA_FULFILLED', payload: response.data,});
        })
        .catch((err) =>{
          dispatch({type: 'GET_CART_DATA_REJECTED', payload: err,})
        })
        let payload = {
          token,
          "air": {
            "items": chkItemArray.air,
          },
          "sea": {
            "items": chkItemArray.sea,
          },
          shipment_location_details,
          insurance,
          warehouse_id,
        }
        if (sc_protect) {
          payload.sc_protect = sc_protect;
        }
				return axios.post(apiUrl + 'shipments', payload);
			},
			(update_error) => {
				dispatch({type: 'UPDATE_INSURED_VALUE_REJECTED', payload: update_error.response,})
			}
		)
		.then(
			(calculate_response) => {
				if(calculate_response) {
					dispatch({type: 'CHECKOUT_ITEM_FULFILLED', payload: calculate_response.data,});
          dispatch({ type: 'PARCEL_UPDATED' });
				}
			},
			(calculate_error) => {
				dispatch({type: 'CHECKOUT_ITEM_REJECTED', payload: calculate_error,})
        dispatch({ type: 'PARCEL_UPDATED' });
			}
		)
		.catch((error) =>{
			// dispatch({type: 'UPDATE_INSURED_VALUE_REJECTED', payload: error.response,})
		});

		if (willResetInsuredError) {
          dispatch({ type: 'PARCEL_UPDATED' });
          dispatch({type: 'RESET_INSURED_VALUE_ERROR', payload: null,});
        }
	}
}

export function getNotification(id){
  return function(dispatch){
    axios.get(apiUrl+'notifications/'+id+'/get-notifications?desktop_only=true')
    .then((response) => {
      dispatch({type: 'GET_NOTIFICATION_FULFILLED', payload: response.data,})
    }).catch((err) =>{
      dispatch({type: 'GET_NOTIFICATION_REJECTED', payload: err,})
    })
  }
 }
export function readNotification(id, read){
  return function(dispatch){
    axios.put(apiUrl+'notifications/'+id,{
      "data":{
        "read":read
        }
    }
    ).then((response) => {
      dispatch({type: 'READ_NOTIFICATION_FULFILLED', payload: response.data,})
      dispatch(getNotification(response.data.data.attributes.party_id))
    }).catch((err) =>{
      dispatch({type: 'GET_NOTIFICATION_REJECTED', payload: err,})
    })
  }
 }
export function readAllNotification(id, read){
  return function(dispatch){
    axios.put(apiUrl+'notifications/'+id+'/read-all',{
      "data":{
        "read":read
        }
    }
    ).then((response) => {
      dispatch({type: 'READ_NOTIFICATION_FULFILLED', payload: response.data,})
      dispatch(getNotification(id))
    }).catch((err) =>{
      dispatch({type: 'GET_NOTIFICATION_REJECTED', payload: err,})
    })
  }
}

export function getCartData(origin = null, offsize = null){
  return function(dispatch)  {
      dispatch({type: 'GET_CART_DATA_FETCHING',});
      axios.post(apiUrl+'users/cart',{"data":{"warehouse":origin,"prohibited":null, offsize}}).then((response) => {
      dispatch({type: 'GET_CART_DATA_FULFILLED', payload: response.data,});
    }).catch((err) =>{
      dispatch({type: 'GET_CART_DATA_REJECTED', payload: err,})
    })
  }
}


/** WEBPACK FOOTER **
 ** ./src/actions/ParcelAction.js
 **/